<template>
	<div>
		<div class="extras" v-if="extras.length > 0">
			<!-- <h4
				class="ch-block-title text-uppercase d-flex flex-row align-items-center p-0 bt-0"
			>
				<span class="ch-title-custom flex-grow-1"
					>3. Add Extras To Your Order</span
				>

				<span class="h4-percent-off">
					{{ discount }}% OFF ALL EXTRAS
				</span>
			</h4> -->

			<div class="row text-uppercase ch-block-title-extras">
				<div class="col-12 col-sm-7 col-md-12 col-lg-7">
					<span>3. Add Extras To Your Order</span>
				</div>
				<div
					class="col-12 col-sm-5 col-md-12 col-lg-5 text-left text-sm-right text-md-left text-lg-right mt-3 mt-sm-0 mt-md-3 mt-lg-0"
				>
					<span class="extras-percent-off"
						>{{ discount }}% OFF ALL EXTRAS</span
					>
				</div>
			</div>

			<ul class="extras-container">
				<li v-for="(e, i) in data" :key="i" class="product-main-list">
					<input
						:id="'extra-' + i"
						name="product-extra"
						type="checkbox"
						class="product-main-checkbox"
						v-model="e.expanded"
						@change="updatePath"
					/>
					<label
						:for="'extra-' + i"
						class="product-options extra-packages d-block"
						:class="{ 'package-selected': e.expanded }"
					>
						<div class="po-extras d-flex align-items-center">
							<!-- Checkbox -->
							<span class="check-box"></span>

							<!-- Name -->
							<span class="po-extra-name flex-grow-1 mr-4">
								{{ e.name }}
							</span>

							<!-- Discount box -->
							<span class="ml-auto text-right flex-shrink-0"
								><span class="po-percent-off" v-if="e.expanded">
									{{ discount }}% OFF
								</span>
							</span>

							<span class="ml-auto text-right" v-if="!e.expanded">
								<span class="small-price gray-text">from</span>
								<br class="d-block d-sm-none" />
								<b>
									{{ e.prices.priceCurrency.first
									}}<span class="small-price"
										>{{ e.prices.priceCurrency.last }}
									</span>
								</b>
							</span>
						</div>
					</label>

					<div
						class="extras-options"
						:class="{
							open: e.expanded,
						}"
					>
						<ul v-if="e.expanded">
							<li
								v-for="(v, vIndex) in e.variantPieces"
								:key="vIndex"
								class="product-main-list sub-list mx-0"
							>
								<input
									:id="'extra-group-' + i + '-' + vIndex"
									:name="'product-main' + i"
									type="radio"
									class="product-main-checkbox"
									:value="v.quantity"
									v-model="e.selected"
									@change="updatePath"
								/>
								<label
									:for="'extra-group-' + i + '-' + vIndex"
									class="product-options po-fix-side d-block"
									:class="{
										'package-selected':
											v.quantity === e.selected,
									}"
								>
									<div
										class="d-none d-lg-flex align-items-center"
									>
										<!-- Checkbox -->
										<span class="check"></span>

										<!-- Save box -->
										<span
											class="d-flex flex-wrap flex-grow-1 align-items-center"
										>
											<span class="pr-2"
												><b>{{ v.quantity }}x</b></span
											>
											<span class="mr-3">{{
												e.name
											}}</span>
											<span class="po-you-save m-0 mt-1">
												You Save:
												<b style="color: #6fb326">{{
													v.prices.priceSaveCurrency
														.full
												}}</b>
											</span>
										</span>

										<!-- Old price/New price -->
										<span
											class="po-last d-flex flex-wrap justify-content-end"
										>
											<span class="po-price-old">
												was
												<del>{{
													v.prices
														.priceOriginalCurrency
														.full
												}}</del>
											</span>
											<div
												class="break flex-basis-100"
											></div>
											<span class="po-price-new">
												<b
													>{{
														v.prices.priceCurrency
															.first
													}}<span class="small-price"
														>{{
															v.prices
																.priceCurrency
																.last
														}}
													</span>
												</b>
											</span>
										</span>
									</div>

									<!-- Mobile -->
									<div
										class="po-container-mobile d-flex d-lg-none align-items-center"
									>
										<!-- Check -->
										<span class="check"></span>

										<div class="br-col"></div>

										<!-- Quantity + Name -->
										<span
											class="d-flex flex-column po-name-mobile mr-4"
										>
											<span>
												<b>{{ v.quantity }}x</b>
												{{ e.name }}
											</span>
										</span>

										<div class="br-col"></div>

										<!-- Old price vs New price -->

										<span
											class="d-flex flex-column ml-auto"
										>
											<!-- Old Price -->
											<span
												class="po-price-old ml-auto text-right"
											>
												<del>{{
													v.prices
														.priceOriginalCurrency
														.full
												}}</del>
											</span>

											<span class="po-price-new ml-auto">
												{{ v.prices.priceCurrency.first
												}}<span class="small-price"
													>{{
														v.prices.priceCurrency
															.last
													}}
												</span>
											</span>
										</span>
									</div>

									<div
										class="d-flex align-items-center justify content-center d-lg-none mt-2"
									>
										<!-- Save box -->
										<span class="po-you-save-mobile">
											You Save:
											<span class="text-green">{{
												v.prices.priceSaveCurrency.full
											}}</span>
										</span>

										<!-- Discount box -->
										<span class="ml-auto">
											<span class="po-percent-off-mobile">
												{{ discount }}% OFF
											</span>
										</span>
									</div>
								</label>
								<label
									:for="'extra-group-' + vIndex"
									class="most-popular-product"
									v-if="v.quantity === e.selected"
									>Selected</label
								>
								<label
									:for="'extra-group-' + vIndex"
									class="most-popular-product"
									v-if="v.promo && v.promo === true"
									>Best Seller</label
								>
							</li>
						</ul>
					</div>
				</li>
			</ul>
		</div>
		<div class="d-none d-md-flex justify-content-center pb-5 px-4 px-sm-5">
			<span
				class="sm-cta mt-4 pulsate-fwd2 gtm3_precheckout_cta"
				id="cta_extras"
				@click="visitCheckout(true)"
				><i class="fas fa-shopping-cart"></i>Proceed To Checkout</span
			>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		extras: {
			type: Array,
			default: () => [],
		},
		discount: {
			type: Number,
			default: 0,
		},
		checkoutPath: {
			type: String,
			default: "https://ohowatch.com",
		},
		beacon: {
			type: Object,
			default: () => {
				return {
					send: false,
					url: "",
				}
			},
		},
	},
	data() {
		return {
			data: [],
		}
	},
	computed: {
		path() {
			let path = ""

			this.data.forEach((x) => {
				if (x.expanded === true) {
					path += x.id + ":" + x.selected + ","
				}
			})

			return path
		},
		prices() {
			let cost = 0
			let savings = 0

			this.data.forEach((x, index) => {
				if (x.expanded === true) {
					cost += this.getVariantPriceByQuantity(x.selected, index)
					savings += this.getVariantSavingsByQuantity(
						x.selected,
						index
					)
				}
			})

			return {
				cost: cost,
				savings: savings,
			}
		},
	},
	methods: {
		addExtras() {
			this.extras.forEach((x) => {
				// Get price for the smallest quantity
				x.prices = this.getPrices({
					// Get the smallest quantity so we can say: "from x price"
					quantity: x.variantPieces.reduce((m, x) =>
						m["quantity"] < x["quantity"] ? m : x
					).quantity,
					discount: this.discount,
					price: x.defaultPrice,
				})

				// Change the variants
				x.variantPieces.map((v) => {
					v.prices = this.getPrices({
						quantity: v.quantity,
						discount: this.discount,
						price: x.prices.price,
					})
				})

				this.data.push({
					...x,
				})
			})
		},
		getPrices(options) {
			return window.getProductPrices(
				{
					quantity: options.quantity,
					discount_percent: options.discount,
				},
				options.price
			)
		},
		updatePath() {
			this.$emit("changeExtras", {
				path: this.path,
				costs: this.prices.cost,
				savings: this.prices.savings,
			})
		},
		getVariantPriceByQuantity(qty, index) {
			let variant = this.data[index].variantPieces.find(
				(x) => x.quantity === qty
			)

			let price = 0

			if (variant) {
				price = variant.prices.priceOriginal
			}

			return parseFloat(price)
		},
		getVariantSavingsByQuantity(qty, index) {
			let variant = this.data[index].variantPieces.find(
				(x) => x.quantity === qty
			)

			let savings = 0

			if (variant) {
				savings = variant.prices.priceSave
			}

			return parseFloat(savings)
		},
		visitCheckout(newTab) {
			if (this.beacon.send && this.beacon.url.length > 3) {
				navigator.sendBeacon(
					"https://trk.topgadgetreport.com/?flux_action=1"
				)
			}
			window.open(this.checkoutPath, newTab == true ? "_blank" : "_self")
		},
	},
	watch: {
		discount(discount) {
			this.data.map((x) => {
				x.prices = this.getPrices({
					quantity: x.variantPieces.reduce((m, x) =>
						m["quantity"] < x["quantity"] ? m : x
					).quantity,
					discount: discount,
					price: x.defaultPrice,
				})

				// Change the variants
				x.variantPieces.map((v) => {
					v.prices = this.getPrices({
						quantity: v.quantity,
						discount: discount,
						price: x.defaultPrice,
					})
				})
			})
		},
	},
	mounted() {
		this.addExtras()
	},
}
</script>

<style lang="scss"></style>
